<template>

    <prognosis
        :index-uri="route('api.v1.financial.prognosis.index')"
        :update-uri="route('api.v1.financial.prognosis.update')"
    ></prognosis>

</template>

<script>

import Prognosis from "../../components/Business/Prognosis";

export default {

    components: {
        Prognosis,
    },

    metaInfo: {
        title:'Prognosis',
    },

    name:'FinancialPrognosis',

}

</script>
